import React from 'react'
import { Link, Route, Routes, useLocation } from 'react-router-dom'
import PlaylistList from './PlaylistList'
import PlaylistEditor from './PlaylistEditor'

const PlaylistAdmin = () => {
  const location = useLocation()

  return (
    <div className='p-4'>
      <h1 className='mb-6 text-2xl font-bold'>Playlist Administration</h1>

      {/* Navigation */}
      <div className='mb-6 flex border-b pb-2'>
        <Link to='/admin/reconciliation' className='px-4 py-2'>
          Reconciliation
        </Link>
        <Link
          to='/admin/playlist'
          className={location.pathname === '/admin/playlist' ? 'px-4 py-2 font-bold' : 'px-4 py-2'}
        >
          Playlists
        </Link>
      </div>

      <Routes>
        <Route path='/' element={<PlaylistList />} />
        <Route path='/edit/:playlistId' element={<PlaylistEditor />} />
        <Route path='/create' element={<PlaylistEditor isNew={true} />} />
      </Routes>
    </div>
  )
}

export default PlaylistAdmin
